import { styled } from "@woba/ds-web";

export const ChartRow = styled("div", {
  display: "flex",
  gap: "$space-04",
  flexWrap: "wrap",
  zIndex: 0,
});
